class Header {
  constructor() {
    this.header = document.querySelector('header');
    this.announcementBar = document.querySelector('.announcement-bar');

    this.#init();
    this.#handleSticky();
    this.#observeSticky();
    this.#setCssProperties();
  }

  #init() {
    window.addEventListener('resize', () => setTimeout(() => this.#setCssProperties(), 300));

    this.search = document.querySelector('header .header__icon--search');
    this.searchInput = document.querySelector('header .header__input');
    this.searchClose = document.querySelector('header .header__icon--cross');

    this.search?.addEventListener('click', e => {
      e.preventDefault();

      this.header.classList.add('search-active');
      this.searchInput.focus();
    });

    this.searchClose?.addEventListener('click', e => {
      e.preventDefault();

      this.header.classList.remove('search-active');
    });
  }

  #observeSticky() {
    window.addEventListener('scroll', this.#handleSticky.bind(this));
  }

  #handleSticky() {
    const position = this.header.offsetHeight + this.header.getBoundingClientRect().top;

    this.header.classList[window.pageYOffset > position ? 'add' : 'remove']('header--sticky');
  }

  #setCssProperties() {
    const headerHeight = this.header ? this.header.offsetHeight : 0;
    const announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;

    document.body.style.setProperty('--header-height', `${ headerHeight }px`);
    document.body.style.setProperty('--announcement-bar-height', `${ announcementBarHeight }px`);
  }
}

document.addEventListener('DOMContentLoaded', () => new Header());
